const React = require("react");
const T = React.PropTypes;

require("./QuestionValidationMessages.less");

const QuestionValidationMessages = React.createClass({
    propTypes: {
        Messages: T.arrayOf(T.string).isRequired
    },
    render() {
        const items = this.props.Messages.map(this.MakeItem);

        return (<ul className="cs-QuestionValidationMessages">
            {items}
        </ul>);
    },
    MakeItem(message, i) {
        return (<li key={i} className="cs-QuestionValidationMessages__item">
            <span className="glyphicon glyphicon-exclamation-sign"></span> {message}
        </li>);
    }
});

module.exports = QuestionValidationMessages;


// WEBPACK FOOTER //
// ./src/components/QuestionValidationMessages/QuestionValidationMessages.jsx